import { useEffect } from "react";
import { useUserStore } from "src/store/userStore";
import { generateWidgetToken } from "src/utils/ticketeduWidgetToken";

const WIDGET_URL = "https://ticketedu.uz/widget.js";
const WIDGET_API_KEY = "tk_PpKWaLL9SNdgKwnHf8JhxAlJB7hwLgG8h6D8YkmV0";
const WIDGET_SECRET = "ws_djdYSQOeCMY0i96sq5t4dZlGWYZLRkXY2opgDqY";

export default function TicketEduWidget() {
  const userInfo = useUserStore((s) => s.userInfo);

  useEffect(() => {
    if (!userInfo || typeof crypto?.subtle === "undefined") return;

    const loadWidget = async () => {
      const script = document.createElement("script");
      script.src = WIDGET_URL;
      script.async = true;

      const token = await generateWidgetToken(WIDGET_SECRET, {
        userId: userInfo.hemisId ?? "unknown",
        userName: userInfo.fullName ?? "",
        ttlSeconds: 3600,
      });

      script.setAttribute("data-api-key", WIDGET_API_KEY);
      script.setAttribute("data-token", token);
      script.setAttribute("data-color", "#6366f1");
      script.setAttribute("data-position", "bottom-right");
      script.setAttribute("data-lang", "uz");

      document.body.appendChild(script);
    };

    if ("requestIdleCallback" in window) {
      (window as any).requestIdleCallback(loadWidget);
    } else {
      setTimeout(loadWidget, 1000);
    }

    return () => {
      const s = document.querySelector(`script[src="${WIDGET_URL}"]`);
      s?.parentElement?.removeChild(s);
    };
  }, [userInfo]);

  return null;
}
